/**
 * @generated SignedSource<<15f9af26780f5df3e046c59e05ec2c75>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ParentMediaType = "cast" | "instagram" | "other" | "tiktok" | "twitter" | "youtube";
import { FragmentRefs } from "relay-runtime";
export type CampaignInputSnsCampaign$data = {
  readonly id: string;
  readonly parentMediaType: ParentMediaType;
  readonly " $fragmentType": "CampaignInputSnsCampaign";
};
export type CampaignInputSnsCampaign$key = {
  readonly " $data"?: CampaignInputSnsCampaign$data;
  readonly " $fragmentSpreads": FragmentRefs<"CampaignInputSnsCampaign">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CampaignInputSnsCampaign",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentMediaType",
      "storageKey": null
    }
  ],
  "type": "Campaign",
  "abstractKey": null
};

(node as any).hash = "6335e5ff67a38fa4a6ed839ea9c3a871";

export default node;
